import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';

/**
 * Testimonials Slider — one Swiper per block instance.
 *
 * ⚠ Navigation selectors come off the element as data attributes rather than by
 * class: a page can hold more than one of these, and a global
 * `.t-slider__nav--next` would wire every slider to the first block's arrows.
 *
 * No autoplay, deliberately — these are long quotes, and it removes the
 * reduced-motion question along with it.
 */
function initTestimonialSliders() {
	document.querySelectorAll('[data-testimonial-slider]').forEach((root) => {
		if (root.dataset.sliderInit) return;
		root.dataset.sliderInit = 'true';

		const el = root.querySelector('.swiper');
		if (!el) return;

		const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		new Swiper(el, {
			modules: [Navigation, A11y],

			/* ⚠ This ladder goes UP, then DOWN, then up again. Not a mistake —
			 * do not "fix" it into a monotonic sequence.
			 *
			 *   <768 1 · 768 2 · 1024 1 · 1280 2 · 1536 3
			 *
			 * The dip at 1024 tracks style.css's `@screen lg`, where .t-slider
			 * becomes a two-column grid and the slider abruptly loses a third of
			 * the page to the intro column.
			 *
			 * ⚠ Swiper's breakpoints are VIEWPORT-based, unlike the container
			 * queries used everywhere else here, so these numbers assume the
			 * block spans the page. */
			slidesPerView: 1,
			spaceBetween: 20,
			breakpoints: {
				768:  { slidesPerView: 2 },
				1024: { slidesPerView: 1 },
				1280: { slidesPerView: 2 },
				1536: { slidesPerView: 3 },
			},

			/* ⚠ Not `loop`: looping clones slides, and a cloned blockquote is
			 * read twice by a screen reader. Finite ends also let the arrows
			 * disable themselves. */
			loop: false,
			speed: reduce ? 0 : 400,

			navigation: {
				prevEl: el.dataset.prev,
				nextEl: el.dataset.next,
			},

			a11y: {
				enabled: true,
				slideLabelMessage: '{{index}} of {{slidesLength}}',
			},
		});

		root.classList.add('is-ready');
	});
}

if (document.readyState !== 'loading') {
	initTestimonialSliders();
} else {
	document.addEventListener('DOMContentLoaded', initTestimonialSliders);
}
